import { Map, Record } from 'immutable';

import CompanyRecord from 'records/company';

const MeRecord = Record({
    company: CompanyRecord(Map()),
    createdAt: '',
    email: '',
    firstName: '',
    fullName: '',
    id: null,
    isAdmin: false,
    lastName: '',
    loggedInAt: '',
    metadata: Map({}),
});

function getHasBetaAccess() {
    return this.get('isAdmin', false) || this.get('company').getHasBetaAccess();
}

function getMetadata() {
    return this.get('metadata', Map({}));
}

MeRecord.prototype.getHasBetaAccess = getHasBetaAccess;
MeRecord.prototype.getMetadata = getMetadata;

export default MeRecord;



// WEBPACK FOOTER //
// ./src/records/me.js